package com.macrofocus.nastac.components

import com.macrofocus.nastac.ui.react.toState
import mui.system.Box
import mui.system.sx
import react.FC
import react.Props
import react.create
import react.useRequired
import web.cssom.Position
import web.cssom.integer
import web.cssom.px

val Caption = FC<Props> {
    val nastac = useRequired(NASTACContext)

    val (viewStyleProbing, _) = nastac.dataLoader.viewStyleProbing.toState()
    val (viewStyleSelection, _) = nastac.dataLoader.viewStyleSelection.toState()

    if(viewStyleSelection.caption != null) {
//        Box {
//            sx {
//                position = Position.absolute
//                left = 330.px
//                top = 16.px
//                width = "calc(100vw - 330px)".unsafeCast<Width>()
//                justifyContent = JustifyContent.center
//                alignItems = AlignItems.center
//                zIndex = integer(1000)
//            }
//
//
//            Typography {
//                variant = TypographyVariant.h6
//                component = h2
//                gutterBottom = true
//
//                sx {
//                    textAlign = TextAlign.center
//                    fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
//                    fontWeight = "500".unsafeCast<FontWeight>()
//                    fontSize = 1.5.em
//                    color = rgb(111, 23, 25)
//                    lineHeight = number(0.95)
//
//                    transition = Transition(
//                        property = TransitionProperty.all,
//                        duration = 1.s,
//                        timingFunction = TransitionTimingFunction.easeInOut
//                    )
//                    if(viewStyleProbing == viewStyleSelection) {
//                        backgroundColor = rgb(255, 255, 255, 0.15) // soft white background
//                        //                    this.color = "#333359"
//                        //                    fontSize = "0.85em"
//                        borderRadius = 8.px
//                        padding = "3px 6px 4px 6px".unsafeCast<LengthProperty>()
//                        boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)".unsafeCast<BoxShadow>()   // subtle drop shadow
//                        this.border = "1px solid rgba(200, 200, 255, 0.3)".unsafeCast<Border>()
//                        //                    `<dynamic>`.pointerEvents = "none"                       // so it doesn't interfere with hover
//                        backdropFilter = "blur(3px)".unsafeCast<BackdropFilter>()
//                    }
//                }
//                +viewStyleSelection.caption
//            }
//        }

//        Box {
//            sx {
//                position = Position.absolute
//                left = 0.px
//                right = 0.px
//                top = 0.px
//                bottom = 0.px
//                zIndex = integer(1000)
//            }
            +viewStyleSelection.caption
//        }
    }

    val s = mutableListOf<FC<Props>>()
    val lg = viewStyleSelection.layerGroup
    if(lg != null) {
//        val vs = lg.viewStyles
//        if(vs != null) {
//            for (v in vs) {
//                println("ViewStyle: ${v.classname}")
//                if(v != null) {
//                    if(nastac != null && nastac.dataLoader != null) {
//                        val layerVisible = v.layerVisible(nastac.dataLoader)
//                        if ((layerVisible == null || layerVisible.value == true)) {
                            if(lg.source != null) {
                                s.addAll(lg.source)
                            }
//                        }
//                    }
//                }
//            }
//        }
    }

    if(s.isNotEmpty()) {
        Box {
            sx {
                position = Position.absolute
                right = 16.px
                bottom = 16.px
                zIndex = integer(1000)
            }

            if(s.size > 1) {
                +"Data sources: "
            } else {
                +"Data source: "
            }
            s.forEachIndexed { index, item ->
                +item.create()
                if (index < s.lastIndex) {
                    +", "
                }
            }
        }
    }
}